import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyGetVisitaByIdQuery, useLazyGetVisitasQuery } from '../../../../services/visitasApi';
import dayjs, { Dayjs } from 'dayjs';

interface ViewExecutionFormData {
    esFallida: boolean;
    actividades: any[];
    totalPersonal: number | null;
    administrativos: number | null;
    personalProduccion: number | null;
    seguridadHigiene: boolean | null;
    profesional: string;
    matricula: string;
    idTipoVisita: number | null;
    idSubTipoVisita: number | null;
    observacion: string;
    firmaPreventor: string;
    firmaResponsable: string;
    fechaVisita: Dayjs | null;
    fechaLimite: Dayjs | null;
    nombreTipoVisita: string;
    idPresentacion: number | null;
    idVisita: number | null;
    id: number | null;
}

export const useViewExecutionVisit = () => {
    const { idVisita } = useParams<{ idVisita: string }>();
    const [fetchVisitaById, { data, isFetching: isFetchingVisit }] = useLazyGetVisitaByIdQuery();
    const [formData, setFormData] = useState<ViewExecutionFormData | null>(null);

    useEffect(() => {
        if (idVisita) {
            fetchVisitaById({ idVisita: Number(idVisita) });
        }
    }, [idVisita, fetchVisitaById]);

    useEffect(() => {
        if (data?.data) {
            const visita = data.data;

            setFormData({
                esFallida: visita.idEstado === 3,
                actividades: visita?.actividades ?? [],
                totalPersonal: visita.totalPersonal ?? null,
                administrativos: visita.administrativos ?? null,
                personalProduccion: visita.personalProduccion ?? null,
                seguridadHigiene: visita?.seguridadHigiene ?? null,
                profesional: visita?.profesional || '',
                matricula: visita?.matricula || '',
                idTipoVisita: visita.idTipoVisita ?? null,
                idSubTipoVisita: visita.idSubTipoVisita ?? null,
                observacion: visita.observacion || '',
                firmaPreventor: visita.firmaPreventor || '',
                firmaResponsable: visita.firmaResponsable || '',
                fechaVisita: visita.fechaVisita ? dayjs(visita.fechaVisita) : null,
                fechaLimite: visita.fechaLimite ? dayjs(visita.fechaLimite) : null,
                nombreTipoVisita: visita.nombreTipoVisita || '',
                idPresentacion: visita.idPresentacion,
                idVisita: visita.idVisita,
                id: visita.id
            });
        }
    }, [data]);

    return {
        formData,
        isLoading: isFetchingVisit
    };
};
